/*
 * Flytter hvert produktkorts .plp-save-badge fra prisblokken op i den tomme
 * .winery-badge-slot, saa det staar paa linje med producenten.
 *
 * Sloten staar tom i markup (snippets/jkl-product-card.liquid) — uden denne
 * flytning falder badget tilbage til sin basisregel i prisblokkens grid, hvor
 * grid-column: 1 / -1 giver det sin egen raekke.
 *
 * Kortet er det samme alle steder, saa flytningen hoerer hjemme eet sted. Laa
 * tidligere som inline-script i jkl-plp, jkl-search og jkl-wishlist — og blev
 * derfor glemt i jkl-product-carousel, hvor badget stod forkert.
 */
(function () {
  // Sektionerne inkluderer hver deres <script src>, saa filen kan blive hentet
  // flere gange paa samme side. Uden vagten ville observerne blive doblet.
  if (window.jklSaveBadgeInit) return;
  window.jklSaveBadgeInit = true;

  function moveSaveBadges() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      var badge = card.querySelector('.plp-save-badge');
      var slot = card.querySelector('.winery-badge');
      if (badge && slot && badge.dataset.moved !== '1') {
        badge.dataset.moved = '1';
        slot.appendChild(badge);
      }
    });
  }

  moveSaveBadges();
  document.addEventListener('DOMContentLoaded', moveSaveBadges);

  // Live-filtrering og infinite scroll skifter kortene ud under listerne, saa
  // de nye kort skal have samme behandling. .product-list er karrusellen, der
  // er statisk i dag — observeren koster intet og daekker den alligevel.
  if (window.MutationObserver) {
    document.querySelectorAll('.plp-product-list, .product-list').forEach(function (list) {
      new MutationObserver(moveSaveBadges).observe(list, { childList: true });
    });
  }
})();
